export default class CollapseListModule{

    constructor(element) {
        this.$wrapper = element;
        this.$dates = this.$wrapper.querySelectorAll('.js-collapse-list-year');
        this.$items = this.$wrapper.querySelectorAll('.js-collapse-list-row');
        this.$trigger  = this.$wrapper.querySelectorAll('.js-collapse-list-trigger');
        this.$content = this.$wrapper.querySelectorAll('.js-collapse-list-content');
        this.bindEvents();
    }


    bindEvents(){
        [].forEach.call(this.$dates, ($trigger, index) => {
            $trigger.addEventListener('click', this.filterByDates.bind(this));
        });
        [].forEach.call(this.$trigger, ($trigger, index) => {
            $trigger.addEventListener('click', this.collapse.bind(this));
        });
    }

    collapse(){
        this.$wrapper.classList.toggle('is-open');
    }

    filterByDates(e){
        let $currentTarget = e.currentTarget;
        let year = $currentTarget.getAttribute('data-year');
        [].forEach.call(this.$dates, ($item, index) => {
            $item.classList.remove('current');
        });
        $currentTarget.classList.add('current');
        if(year === 'all'){
            [].forEach.call(this.$items, ($item, index) => {
                $item.classList.remove('is-hidden');
            });
        }
        else{
            [].forEach.call(this.$items, ($item, index) => {
                let itemYear = $item.getAttribute('data-year');
                if(year === itemYear ){
                    $item.classList.remove('is-hidden');
                }
                else{
                    $item.classList.add('is-hidden');
                }
            });
        }
    }

}